<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }}<span v-if="box.extra" class="extra_price"
             v-bind:style="[(selected === 'yes' ? {visibility: 'visible'} : {visibility: 'hidden'})]"> + {{ box.extra }} €</span>
        </div>
        <!-- SEARCHBOX -->

        <!-- FILTERBOXES -->
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <div class="fabric-select-btn-box">
            <div class="designer-select-dropdown">
                <div class="designer-select-dropdown-col">
                    <h3>{{ translations['Hankerchief'] }}</h3>
                    <div id="hankerchief" class="designer-select">
                        <select title="{{ translations['Hankerchief'] }}" id="hankerchief"
                                name="{{ translations['Hankerchief'] }}" @change="updatePersonal"
                                v-model="selected">
                            <option value="none">{{ translations['No'] }}</option>
                            <option value="yes">{{ translations['Yes'] }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="designer-select-dropdown">
                <div class="designer-select-dropdown-col">
                    <p>{{ translations['Do you wish to have a tailorjack-label sewed on your shirt?'] }}</p>
                    <h3>{{ translations['tailorjack-Logo'] }}</h3>
                    <div id="tj_logo" class="designer-select">
                        <select title="{{ translations['Tailorjack-Logo'] }}" id="tj_logo"
                                name="{{ translations['Tailorjack-Logo'] }}" @change="updatePersonal"
                                v-model="selectedlogo">
                            <option value="yes">{{ translations['Yes'] }}</option>
                            <option value="none">{{ translations['No'] }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Hankerchief',
  props: ['fabrics', 'items', 'box', 'filtertext', 'personal', 'isactive', 'translations'],
  data: function () {
    return {
      selected: (typeof this.personal['hankerchief'] !== 'undefined' ? this.personal['hankerchief'] : ''),
      selectedlogo: (typeof this.personal['tj_logo'] !== 'undefined' ? this.personal['tj_logo'] : '')
    }
  },
  methods: {
    updatePersonal: function (event) {
      if (event.currentTarget.id === 'hankerchief') {
        this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected])
      } else if (event.currentTarget.id === 'tj_logo') {
        this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selectedlogo])
      }
    }
  },
  ready: function () {
    this.$dispatch('runDesignJQuery')
  }
}
</script>



// WEBPACK FOOTER //
// Hankerchief.vue?50f098a7